import * as React from "react";

import { CardBox } from "../components";

interface ToolCallQuestionProps {
  question: string;
}

export const ToolCallQuestion: React.FC<ToolCallQuestionProps> = ({ question }) => {
  if (!question) return null;
  
  return (
    <CardBox title="Question" titleColor="text-primary">
      <div className="text-sm">{question}</div>
    </CardBox>
  );
};